import Vue from 'vue'
import Router from 'vue-router'
import health from '../views/health.vue'
import patient from '../views/patient.vue'
import healthcom from '../views/item/healthcom.vue'

Vue.use(Router)

export default new Router({
    mode:"history",
    base: '/wysy/',
    routes: [{
            path: '/',
            name: 'home',
            meta: {
                showTab: true
            },
            component: () =>
                import ('../views/home.vue')
        },
        {
            path: '/peixun',
            name: 'peixun',
            meta: {
                showTab: true
            },
            component: () =>
                import ('../views/peixun.vue')
        },
        {
            path: '/article',
            name: 'article',
            component: () =>
                import ('../views/article.vue')
        },
        {
            path: '/wode',
            name: 'wode',
            meta: {
                showTab: true
            },
            component: () =>
                import ('../views/wode.vue')
        },
        {
            path: '/health',
            name: 'health',
            component: () =>
                import ('../views/health.vue')
        },
      {
        path: '/patient1',
        name: 'patient1',
        component: () =>
          import ('../views/patient1.vue')
      },
        {
          path: '/healthcom',
          name: 'healthcom',
          component: () =>
            import ('../views/item/healthcom.vue')
        },
        {
            path: '/patient',
            name: 'patient',
            component: () =>
                import ('../views/patient.vue')
        },
        {
            path: '/notice',
            name: 'notice',
            component: () =>
                import ('../views/setting/notice.vue')
        },
        {
            path: '/noticelist',
            name: 'noticelist',
            component: () =>
                import ('../views/setting/noticelist.vue')
        },
      {
        path: '/noticelistmsg',
        name: 'noticelistmsg',
        component: () =>
          import ('../views/setting/noticelistmsg.vue')
      },
        {
            path: '/erweima',
            name: 'erweima',
            component: () =>
                import ('../views/setting/erweima.vue')
        },
        {
            path: '/person',
            name: 'person',
            component: () =>
                import ('../views/setting/person.vue')
        },
        {
            path: '/bmi',
            name: 'bmi',
            component: () =>
                import ('../views/setting/bmi.vue')
        },
        {
            path: '/erweilist',
            name: 'erweilist',
            component: () =>
                import ('../views/setting/erweilist.vue')
        },
        {
            path: '/renzheng',
            name: 'renzheng',
            component: () =>
                import ('../views/setting/renzheng.vue')
        },
        {
            path: '/tougao',
            name: 'tougao',
            component: () =>
                import ('../views/setting/tougao.vue')
        },
        {
            path: '/mobile',
            name: 'mobile',
            component: () =>
                import ('../views/setting/mobile.vue')
        },
        {
            path: '/tuiguang',
            name: 'tuiguang',
            component: () =>
                import ('../views/setting/tuiguang.vue')
        },
        {
            path: '/details',
            name: 'details',
            component: () =>
                import ('../views/item/details.vue')
        },
        {
          path: '/pdetails',
          name: 'pdetails',
          component: () =>
            import ('../views/item/pdetails.vue')
        },
        {
            path: '/baoming',
            name: 'baoming',
            component: () =>
                import ('../views/item/baoming.vue')
        },
        {
            path: '/baominglist',
            name: 'baominglist',
            component: () =>
                import ('../views/item/baominglist.vue')
        },
        {
            path: '/favourite',
            name: 'favourite',
            component: () =>
                import ('../views/item/favourite.vue')
        },
        {
            path: '/recommend',
            name: 'recommend',
            component: () =>
                import ('../views/item/recommend.vue')
        },
        {
            path: '/recomlist',
            name: 'recomlist',
            component: () =>
                import ('../views/item/recomlist.vue')
        },
        {
            path: '/commission',
            name: 'commission',
            component: () =>
                //我的佣金
                import ('../views/item/commission.vue')
        },
        {
            path: '/apply',
            name: 'apply',
            component: () =>
                //我的佣金
                import ('../views/item/apply.vue')
        },
        {
          path: '/newlist',
          name: 'newlist',
          component: () =>
            //列表页
            import ('../views/item/newlist.vue')
        },
        {
          path: '/question',
          name: 'question',
          component: () =>
            //列表页
            import ('../views/setting/question.vue')
        },
        {
            path: '/applylist',
            name: 'applylist',
            component: () =>
                //我的佣金
                import ('../views/item/applylist.vue')
        },
        {
            path: '/record',
            name: 'record',
            component: () =>
                //我的提现记录
                import ('../views/item/record.vue')
        },
        {
            path: '/success',
            name: 'success',
            component: () =>
                import ('../views/item/success.vue')
        },
        {
            path: '/outgroup',
            name: 'outgroup',
            component: () =>
                import ('../views/item/outgroup.vue')
        },
        {
            path: '/duibi',
            name: 'duibi',
            component: () =>
                import ('../views/item/duibi.vue')
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js